import { useParams } from 'react-router-dom'
import EditUserForm from './EditUserForm'
import { useGetGroupsQuery } from '../groups/groupsApiSlice'
import { useGetUsersQuery } from './usersApiSlice'
import PulseLoader from 'react-spinners/PulseLoader'
import useTitle from '../../hooks/useTitle'

const EditUser = () => {
    useTitle('geshtop-Exercise: Edit User')

    const { userId } = useParams()

    const { user } = useGetUsersQuery("usersList", {
        selectFromResult: ({ data }) => ({
            user: data?.entities[userId]
        }),
    })

    const { groups } = useGetGroupsQuery("groupsList", {
        selectFromResult: ({ data }) => ({
            groups: data?.ids.map(id => data?.entities[id])
        }),
    })

    if (!user || !groups) return <PulseLoader color={"#FFF"} />

    const content = <EditUserForm user={user} groups={groups} />

    return content
}
export default EditUser